import apiClient from 'services/apiClient';
import { listMetaFlowSubmissions } from 'services/metaFlowService';

export function normalizePhoneDigits(number) {
  return String(number || '').replace(/\D/g, '');
}

export function getComparisonKey(number) {
  const clean = normalizePhoneDigits(number);
  return clean.length >= 10 ? clean.slice(-10) : clean;
}

export function dedupeLeadsByNumber(leads) {
  const byNumber = new Map();

  for (const lead of leads) {
    const number = String(lead?.wa_id || '').trim();
    if (!number) {
      continue;
    }

    const key = getComparisonKey(number) || number;
    if (!byNumber.has(key)) {
      byNumber.set(key, {
        key,
        name: String(lead?.contact_name || '').trim(),
        number,
      });
      continue;
    }

    const existing = byNumber.get(key);
    if (!existing.name && lead?.contact_name) {
      existing.name = String(lead.contact_name).trim();
    }
  }

  return Array.from(byNumber.values());
}

export function markContactsInGroup(contacts, groupContacts) {
  const existingNumbers = new Set(
    (groupContacts || [])
      .map((contact) => getComparisonKey(contact?.number))
      .filter(Boolean),
  );

  return contacts.map((contact) => ({
    ...contact,
    inGroup: existingNumbers.has(getComparisonKey(contact.number)),
  }));
}

export async function fetchUserGroups({ api, authToken, userId }) {
  const response = await apiClient.get(`${api}groups/${userId}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });

  return response.data?.groups || [];
}

export async function fetchGroupContacts({ api, authToken, groupId }) {
  const response = await apiClient.get(`${api}edit-group/${groupId}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });

  return response.data?.groups?.contacts || [];
}

export async function fetchAllFlowLeads({ metaFlowId, status, search }) {
  let page = 1;
  const all = [];

  while (true) {
    const data = await listMetaFlowSubmissions({
      meta_flow_id: metaFlowId,
      status,
      search: search?.trim() || undefined,
      page,
      per_page: 100,
    });

    all.push(...(data?.data || []));

    const lastPage = data?.meta?.last_page || 1;
    if (page >= lastPage) {
      break;
    }
    page += 1;
  }

  return all;
}

export async function fetchAllCampaignLeads({
  api,
  authToken,
  campaignId,
  status,
  search,
}) {
  let page = 1;
  const all = [];

  while (true) {
    const params = {
      page,
      per_page: 100,
      status,
    };
    if (search?.trim()) {
      params.search = search.trim();
    }

    const response = await apiClient.get(`${api}campaign-flow-leads/${campaignId}`, {
      headers: { Authorization: `Bearer ${authToken}` },
      params,
    });

    all.push(...(response.data?.data || []));

    const lastPage = response.data?.pagination?.last_page || 1;
    if (page >= lastPage) {
      break;
    }
    page += 1;
  }

  return all;
}
